import ModalContent from './ModalContent';
import ModalContentBody from './ModalContentBody';
import ModalContentFooter from './ModalContentFooter';

export { ModalContent, ModalContentBody, ModalContentFooter };
